import { OnlineContactDetails } from "./OnlineContactDetails";
import { QRWaiterContactDetails } from "./QRWaiterContactDetails";
export const ContactDetails = {
    empty(params) {
        return params.isQrWaiterOrder
            ? QRWaiterContactDetails.empty()
            : OnlineContactDetails.empty(params.validatePhoneService);
    },
};
